<template>
  <el-row :gutter="10"
          class="processed-skus"
          :class="{ 'with-type': showType }">
    <el-col v-if="name"
            :span="4"
            class="processed-skus__indicator name">
      {{ name }}
    </el-col>
    <IndicatorColumn :counts="counts"
                     :show-processed-count="showProcessedCount"
                     indicator-type="normal"
                     :indicator-title="$t('SKU')"
                     @addToPoolBulkMode="handleAddToPoolBulkMode('sku', name)" />
    <IndicatorColumn :counts="counts"
                     :show-processed-count="showProcessedCount"
                     indicator-type="unrecognized"
                     :indicator-title="$t('Unrecognized')"
                     @addToPoolBulkMode="handleAddToPoolBulkMode('unrecognized', name)" />
    <IndicatorColumn :counts="counts"
                     :show-processed-count="showProcessedCount"
                     indicator-type="meta"
                     :indicator-title="$t('Meta')"
                     @addToPoolBulkMode="handleAddToPoolBulkMode('meta', name)" />
  </el-row>
</template>

<script>
import IndicatorColumn from '@/modules/sku-validation/components/IndicatorColumn';

export default {
  components: {
    IndicatorColumn
  },
  props: {
    showType: {
      type: Boolean,
      default: false
    },
    showProcessedCount: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    counts: {
      type: Object,
      required: true
    },
    visitLevelCrops: {
      type: Array,
      default() {
        return [];
      }
    },
    imageSetLevelCrops: {
      type: Array,
      default() {
        return [];
      }
    },
    imageLevelCrops: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  methods: {
    handleAddToPoolBulkMode(type, level) {
      switch (level) {
        case 'Visit':
          this.getCurrentLevelTypeCrops(type, this.visitLevelCrops);
          break;
        case 'Imageset':
          this.getCurrentLevelTypeCrops(type, this.imageSetLevelCrops);
          break;
        case 'Image':
          this.getCurrentLevelTypeCrops(type, this.imageLevelCrops);
          break;
        default:
          break;
      }
    },
    getCurrentLevelTypeCrops(type, cropList) {
      switch (type) {
        case 'sku':
          this.$emit('addBulkCropToPool', { cropList: cropList.filter(crop => crop.is_sku), type, level: this.name });
          break;
        case 'unrecognized':
          this.$emit('addBulkCropToPool', { cropList: cropList.filter(crop => crop.is_unrecognized), type, level: this.name });
          break;
        case 'meta':
          this.$emit('addBulkCropToPool', { cropList: cropList.filter(crop => crop.is_meta), type, level: this.name });
          break;
        default:
          break;
      }
    }
  }
};
</script>

<style lang="scss">
.processed-skus {
  display: flex;
  align-self: flex-end;
  justify-content: space-between;
  width: 500px;
  height: 100%;
  margin-bottom: 1px;

  &:not(.with-type) {
    .type {
      display: none;
    }
  }

  &__indicator {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: flex-end;
    font-size: 14px;

    &-count {
      display: flex;
      align-items: baseline;
      justify-content: space-around;
      width: 100%;
      margin-top: 10px;

      .counts {
        flex: 1;
        font-size: 16px;
        font-weight: 600;
        text-align: center;
      }

      .processed-count {
        flex: 1;
        font-weight: 600;
        text-align: center;
        transition-duration: 0.1s;

        i {
          margin-right: 10px;
          font-size: 16px;
        }
      }
    }

    .type {
      flex: 0 0 100%;
      padding: 1px 0;
      margin-bottom: 5px;
      font-size: 14px;
      text-align: center;
      text-transform: uppercase;
      border-radius: 4px;
    }

    .info {
      width: 100%;
      margin-top: 20px;

      .add-to-pool,
      .info-arrow {
        display: none;
      }

      &:hover {
        margin-top: 0;
        color: #fff;
        cursor: pointer;

        .add-to-pool {
          display: inherit;
          font-size: 14px;
          font-weight: 600;
          text-align: center;
        }

        .info-arrow {
          display: inherit;
          font-size: 16px;
          color: #fff;
        }

        &.normal {
          background: #4a90e2;
          border-radius: 5px;

          .mdi-check-circle-outline {
            &::before {
              color: #4a90e2;
              background: #fff;
              border-radius: 20px;
            }
          }
        }

        &.unrecognized {
          background: #51cfc3;
          border-radius: 5px;

          .mdi-check-circle-outline {
            &::before {
              color: #51cfc3;
              background: #fff;
              border-radius: 20px;
            }
          }
        }

        &.meta {
          background: #eddb02;
          border-radius: 5px;

          .mdi-check-circle-outline {
            &::before {
              color: #eddb02;
              background: #fff;
              border-radius: 10px;
            }
          }
        }
      }
    }

    &.normal {
      color: $brilliantAzure;

      .type {
        background-color: rgba($brilliantAzure, 0.4);
      }
    }

    &.name {
      font-size: 14px;
      font-weight: 600;
      color: #9e9e9e;
    }

    &.unrecognized {
      color: #57e0c1;

      .type {
        background-color: rgba(#57e0c1, 0.4);
      }
    }

    &.meta {
      color: #ecd930;

      .type {
        background-color: rgba(#ecd930, 0.3);
      }
    }

    &.non-sku {
      color: #f60;

      .type {
        background-color: rgba(#f60, 0.3);
      }
    }

    &.align-center {
      justify-content: center;
    }
  }
}
</style>
